export const HSY_PAGE = {
  待开发票: {
    path: '/account/invoice-collaboration/pending-invoice',
  },
  红字信息表: {
    path: '/account/invoice-collaboration/redtable',
  },
  组织设置: {
    path: '/account/conf/org/add?updateCurrent=1&status=edit',
  },
}
export const HSY_PAGE = {
  待开发票: {
    path: '/account/invoice-collaboration/pending-invoice',
  },
  红字信息表: {
    path: '/account/invoice-collaboration/redtable',
  },
  组织设置: {
    path: '/account/conf/org/add?updateCurrent=1&status=edit',
  },
}
